import React from 'react'
import { Outlet } from 'react-router-dom'
import { Box, Container, Stack, styled } from '@mui/material'
import useResponsive from '../hooks/useResponsive'
import Logo from '../components/Logo'
import { useTheme } from '@mui/material/styles'

export function AuthLayout () {
  const StyledRoot = styled('div')(({ theme }) => ({
    [theme.breakpoints.up('md')]: {
      display: 'flex'
    }
  }))
  const StyledSection = styled('div')(({ theme }: any) => ({
    width: '100%',
    maxWidth: 900,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: theme.customShadows.card,
    backgroundColor: theme.palette.background.neutral
  }))
  const StyledContent = styled('div')(({ theme }) => ({
    maxWidth: 400,
    margin: 'auto',
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: theme.spacing(12, 0)
  }))
  const mdUp = useResponsive('up', 'md')
  const theme = useTheme()
  return (
    <Box flex={1}>
      <StyledRoot>
        {mdUp && (
          <StyledSection>
            <Logo sx={{ width: 600, height: 162 }} />
          </StyledSection>
        )}
        <Container maxWidth="sm">
          <StyledContent>
            {!mdUp && <Box
              component="img"
              alignContent={'center'}
              mb={2}
              src={require((theme.palette.mode === 'dark') ? '../assets/images/logo-dark.png' : '../assets/images/logo-light.png')}/>
            }
            <Outlet />
          </StyledContent>
        </Container>
      </StyledRoot>
    </Box>
  )
}
